import { z } from "zod";


export const CentroCustoSchema = z.object({
    idCentroCusto: z.coerce.number(),
    status: z.coerce.number(),
    codigo: z.string().nonempty({ message: "É necessário preencher este campo!" }),
    descricao: z.string().nonempty({ message: "É necessário preencher este campo!" }),
    bdi: z.coerce.number().nullable().optional(),
    bdi2: z.coerce.number().nullable().optional(),
    numeroCno: z.string().nullable().optional(),
    obsCentroCusto: z.string().nullable().optional()

});

export type CentroCustoForm = z.infer<typeof CentroCustoSchema>;

export const defaultCentroCustoForm: Partial<CentroCustoForm> = {
    idCentroCusto: 0,
    status: 0,
}